import React from 'react';
import PropTypes from 'prop-types';
import S from 'calendar.scss';

const CalendarBlock = ({ reason, onSelect, adjustedStartTime }) => <div className={S.ssBlock}>
  <p>{reason}</p>
  {adjustedStartTime && <p // eslint-disable-line jsx-a11y/no-static-element-interactions
    className={S.assigneeLink}
    onClick={onSelect}
  >Schedule at {adjustedStartTime}</p>}
</div>;

CalendarBlock.propTypes = {
  reason: PropTypes.string.isRequired,
  adjustedStartTime: PropTypes.string,
  onSelect: PropTypes.func,
};

export default CalendarBlock;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarBlock.jsx